"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ProductImage = _interopRequireDefault(require("@sprinx/react-com/ProductImage"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var useStyles = (0, _makeStyles.default)(function () {
  return {
    root: {// width: ({ mobile }) => mobile && 50,
      // height: ({ mobile }) => mobile && 50,
    }
  };
}, {
  name: 'AppMainNavigationNestItem'
});

function AppMainNavigationNestItem(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      size = _ref.size,
      src = _ref.src,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "size", "src"]);
  var theme = (0, _useTheme.default)();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down('xs'));
  var classes = useStyles({
    className: className,
    classes: pClasses,
    mobile: mobile
  });
  return /*#__PURE__*/_react.default.createElement(_ProductImage.default, (0, _extends2.default)({}, rest, {
    classes: {
      root: classes.root,
      className: className
    },
    size: size,
    src: src
  }));
}

process.env.NODE_ENV !== "production" ? AppMainNavigationNestItem.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  size: _propTypes.default.oneOf(['mini', 'small', 'normal', 'big']),
  src: _propTypes.default.string
} : void 0;
AppMainNavigationNestItem.defaultProps = {
  classes: undefined,
  className: undefined,
  size: 'mini',
  src: _propTypes.default.string
};
var _default = AppMainNavigationNestItem;
exports.default = _default;